/* ============================================================
   ARCTIC ORGANICS - BLOG JOURNAL ARTICLE TEMPLATE
   Dependency-free vanilla JS. Everything is guarded so it
   no-ops when its elements are absent.
   - reading progress bar
   - auto-build numbered TOC from body h2 elements + scroll-spy
   - copy-link "Copied" feedback
   - mobile sticky CTA reveal after ~700px on screens < 1000px
   FAQ uses native <details>, no JS needed.
   ============================================================ */
(function () {
  var root = document.querySelector('.ao-article');
  if (!root) return;

  /* ---------- slugify helper ---------- */
  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .replace(/[‘’“”]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
  }

  /* ---------- auto TOC build ---------- */
  var toc = document.getElementById('ao-toc');
  var tocBox = document.getElementById('ao-tocbox');
  var tocList = document.getElementById('ao-toc-list');
  var body = root.querySelector('.ao-article__body');
  var links = [];
  var targets = [];

  if (toc && tocList && body) {
    var headings = [].slice.call(body.querySelectorAll(':scope > h2'));
    var used = {};
    if (headings.length) {
      headings.forEach(function (h) {
        var id = h.id;
        if (!id) {
          id = slugify(h.textContent);
          while (used[id] || document.getElementById(id)) {
            id = id + '-x';
          }
          h.id = id;
        }
        used[id] = true;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        tocList.appendChild(li);
        links.push(a);
        targets.push(h);
      });
    } else {
      // No headings: hide the whole TOC rail.
      toc.setAttribute('hidden', 'hidden');
    }
  }

  /* ---------- TOC: open on desktop (summary hidden), collapsed on mobile ---------- */
  if (tocBox && window.matchMedia) {
    var mq = window.matchMedia('(min-width:1000px)');
    var syncToc = function () { if (mq.matches) tocBox.open = true; };
    if (mq.addEventListener) mq.addEventListener('change', syncToc);
    else if (mq.addListener) mq.addListener(syncToc);
    syncToc();
  }

  /* ---------- TOC scroll-spy ---------- */
  if (links.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = targets.indexOf(e.target);
        links.forEach(function (l, j) { l.classList.toggle('is-active', j === i); });
      });
    }, { rootMargin: '-15% 0px -75% 0px' });
    targets.forEach(function (t) { if (t) io.observe(t); });
  }

  /* ---------- progress bar + mobile sticky CTA ---------- */
  var bar = document.getElementById('ao-progress');
  var mcta = document.getElementById('ao-mcta');
  function onScroll() {
    if (bar) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.style.width = p + '%';
    }
    if (mcta) {
      if (window.scrollY > 700) mcta.classList.add('on');
      else mcta.classList.remove('on');
    }
  }
  if (bar || mcta) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- FAQPage JSON-LD (built client-side from the authored .ao-faq) ---------- */
  (function buildFaqJsonLd() {
    var faq = root.querySelector('.ao-faq');
    if (!faq) return;
    // Each Q is a <summary> (or [data-question]); its answer is the rest of the parent block.
    var items = [];
    var blocks = [].slice.call(faq.querySelectorAll('details'));
    if (!blocks.length) {
      // Fallback: pair summary/heading elements with their following content.
      blocks = [].slice.call(faq.querySelectorAll('summary, [data-question]'));
    }
    blocks.forEach(function (block) {
      var qEl, aText;
      if (block.tagName === 'DETAILS') {
        qEl = block.querySelector('summary, [data-question]');
        if (!qEl) return;
        var clone = block.cloneNode(true);
        var qClone = clone.querySelector('summary, [data-question]');
        if (qClone) qClone.parentNode.removeChild(qClone);
        aText = clone.textContent;
      } else {
        qEl = block;
        var ans = block.nextElementSibling;
        aText = ans ? ans.textContent : '';
      }
      var q = (qEl.textContent || '').trim();
      var a = (aText || '').replace(/\s+/g, ' ').trim();
      if (q && a) {
        items.push({
          '@type': 'Question',
          name: q,
          acceptedAnswer: { '@type': 'Answer', text: a }
        });
      }
    });
    if (!items.length) return;
    var data = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: items
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  })();

  /* ---------- copy link ---------- */
  var copy = document.getElementById('ao-copy');
  if (copy) {
    copy.addEventListener('click', function (e) {
      e.preventDefault();
      var url = copy.getAttribute('data-url') || location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
      }
      var t = copy.textContent;
      copy.textContent = 'Copied';
      setTimeout(function () { copy.textContent = t; }, 1600);
    });
  }
})();
